import { Box, Switch, Typography } from "@mui/material";
import __ from "src/utils/Translations";
import { Controller, Control } from "react-hook-form";
import { TModuleSettingsPayload } from "src/Pages/Company/OrganizationStructure/ModuleSettings/moduleSettings.models";

const Field = ({
  control,
  name,
  title,
  subtitle,
}: {
  // eslint-disable-next-line
  control: Control<TModuleSettingsPayload, any>;
  name: keyof TModuleSettingsPayload;
  title: string;
  subtitle?: string;
}) => (
  <Box>
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Typography sx={{ fontSize: "16px" }}>{__(title)}</Typography>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Switch
            {...field}
            checked={field.value}
            data-testid={`os__module-settings-${name}-switch`}
          />
        )}
      />
    </Box>
    {subtitle && (
      <Typography
        sx={{ fontSize: "12px", width: "700px" }}
        color="text.secondary"
      >
        {__(subtitle)}
      </Typography>
    )}
  </Box>
);

export default Field;
